import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, XCircle } from 'lucide-react';
export function PainPointsSection() {
  const painPoints = ['Lanzas una campaña, ves 2 días flojos y mueves todo.', 'Cambias creativos, segmentaciones, ubicaciones, textos… sin orden.', 'Subes presupuesto cuando "parece que va bien" y de repente se muere.', 'Apagas conjuntos que "no gastan" o "no convierten" demasiado pronto.', 'Te quedas mirando el Ads Manager como si fuera una bolsa de valores.'];
  return <section className="py-20 px-4 bg-[#0d0d14]" data-id="element-78">
      <div className="max-w-4xl mx-auto" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-80">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white" data-id="element-81">
            La verdad incómoda: la mayoría está{' '}
            <span className="text-red-500" data-id="element-82">saboteando</span> sus propias
            campañas
          </h2>
          <p className="text-xl text-gray-400" data-id="element-83">Mira si te suena familiar:</p>
        </motion.div>

        <div className="bg-[#15151e] border border-gray-800 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-84">
          <div className="space-y-6" data-id="element-85">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start" data-id="element-86">
                <XCircle className="w-6 h-6 text-red-500 mr-4 flex-shrink-0 mt-1" data-id="element-87" />
                <p className="text-lg text-gray-300" data-id="element-88">{point}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="mt-10 pt-8 border-t border-gray-800" data-id="element-89">
            <div className="flex items-start bg-red-500/10 border border-red-500/20 rounded-lg p-6" data-id="element-90">
              <AlertTriangle className="w-8 h-8 text-red-500 mr-4 flex-shrink-0" data-id="element-91" />
              <div data-id="element-92">
                <p className="text-lg font-semibold text-white mb-2" data-id="element-93">
                  El resultado:
                </p>
                <p className="text-gray-400" data-id="element-94">
                  Andrómeda no alcanza estabilidad, no acumula señales limpias,
                  y tú terminas con la sensación de que Meta es una ruleta.
                </p>
                <p className="text-xl font-bold text-blue-400 mt-4" data-id="element-95">
                  No lo es. Solo necesitas el mapa correcto.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}